import React, {useState, useEffect} from 'react'
import {TopicText} from './styles'
import {OntarioIconChevronRight} from '@ongov/ontario-design-system-component-library-react'

export const Topic = ({t, metadata, isLawsTopic = false}) => {
  const [topic, setTopic] = useState(null)
  const setTopicIfPresent = metadataJson => {
    if (metadataJson?.topicTag?.length > 0) {
      setTopic(metadataJson?.topicTag?.split('|'))
    }
  }

  useEffect(() => {
    if (metadata) {
      if (isLawsTopic) {
        setTopic([t('header.filters.elaws'), metadata])
      } else {
        const txt = document.createElement('textarea')
        txt.innerHTML = metadata
        const metadataJson = JSON.parse(txt.value)
        setTopicIfPresent(metadataJson)
      }
    } else if (isLawsTopic) {
      setTopic([t('header.filters.elaws')])
    }
  }, [metadata, isLawsTopic, t])

  return topic?.some(Boolean) ? (
    <TopicText>
      <ul className="breadcrumbs" data-testing="result-breadcrumb">
        {topic.map((tp, index) => (
          <li key={index}>
            {index > 0 ? (
              <>
                <OntarioIconChevronRight
                  colour="grey"
                  icon-width="24"
                  className="breadcrumbChevron"
                />
                {''}
              </>
            ) : (
              ''
            )}
            {tp}
          </li>
        ))}
      </ul>
    </TopicText>
  ) : null
}
